import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import styles from "./LoadMoreWithExtendedDate.module.scss";
import { useTranslation } from "react-i18next";
import { Space } from "antd"

const { ViewMore, ViewMoreText } = styles;

function LoadMoreWithExtendedDate({ style, onClick }) {
    const { t } = useTranslation();

    return (
        <div className={ViewMore} style={{ ...style }} onClick={onClick}>
            <Space
                direction="vertical"
                size="small"
                style={{
                display: 'flex',
                }}
            >
                <span className={ViewMoreText}>
                    {t("filters.extendTimeFrame")} <FontAwesomeIcon icon={faChevronDown} />
                </span>
            </Space>
        </div>
    );
}

export default LoadMoreWithExtendedDate;
